export type DataAttributes = { [key: string]: string }

export const mapDataAttributes = (dataAttributes: DataAttributes): DataAttributes =>
  Object.entries(dataAttributes).reduce((current: DataAttributes, [key, value]: [string, string]) => {
    current[`data-${key}`] = value
    return current
  }, {})
